let tinymceKey = 'ni2n75chwno502kky2y3okwhegmp1ce01xjr90g89t57rotn'; // dev
if (process.env.NODE_ENV === 'production') {
    tinymceKey = '5jt73tqxio63i6z6uzqvhvgwddfmyj8y31k12lirl3j5eh4m'; // prod
}
console.log('env:', process.env.NODE_ENV);
export { tinymceKey };
